import { SET_MESSAGE_CONCLUSAO } from './types';
import { toast, ToastContainer } from 'react-toastify';
import React, { Component }  from 'react';

export const setMessageConclusaoAction = obj =>{

  if(obj.isError){
    toast.warn(
    <div>
      <p>{obj.discription}</p>
      <br/>
      <p>{obj.error}</p>
    </div>,
      {
        position: toast.POSITION.BOTTOM_RIGHT,
        className:"ui-alert-toast"
      }
    );
  }
  
  return {
    type: SET_MESSAGE_CONCLUSAO,
    payload: obj
  };
} 
